// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trace-container {
  padding: 20px;
  margin: 20px auto;
  padding: 20px;
  background-color: #f5f7fa;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

.trace-title {
  text-align: center;
  font-size: 24px;
  margin-bottom: 10px;
}

.trace-input-area {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.trace-input {
  flex: 1 1;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #1f2a44;
  background: #111a2e;
  color: #fff;
}

.btn {
  padding: 10px 14px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.start {
  width: 200px;
  background: #008000;
  color: #00ffcc;
}

.stop {
  width: 200px;
  background: #ff3d00;
  color: #fff;
}

.clear {
  width: 200px;
  background: #2962ff;
  color: #fff;
}

.trace-status {
  margin: 10px 0;
  color: #aaa;
}

.trace-output {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.hop-card {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  background: #111a2e;
  border-left: 3px solid #00ffcc;
  border-radius: 6px;
}

.hop-left {
  display: flex;
  gap: 10px;
}

.hop-index {
  color: #00ffcc;
}

.hop-ip {
  color: #fff;
}

.hop-right {
  display: flex;
  gap: 15px;
  color: #aaa;
}

.latency {
  color: #00ffcc;
}`, "",{"version":3,"sources":["webpack://./src/components/DiagnosticTools/Traceroute.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".trace-container {\n  padding: 20px;\n  margin: 20px auto;\n  padding: 20px;\n  background-color: #f5f7fa;\n  border-radius: 8px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  box-sizing: border-box;\n}\n\n.trace-title {\n  text-align: center;\n  font-size: 24px;\n  margin-bottom: 10px;\n}\n\n.trace-input-area {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.trace-input {\n  flex: 1;\n  padding: 10px;\n  border-radius: 6px;\n  border: 1px solid #1f2a44;\n  background: #111a2e;\n  color: #fff;\n}\n\n.btn {\n  padding: 10px 14px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.start {\n  width: 200px;\n  background: #008000;\n  color: #00ffcc;\n}\n\n.stop {\n  width: 200px;\n  background: #ff3d00;\n  color: #fff;\n}\n\n.clear {\n  width: 200px;\n  background: #2962ff;\n  color: #fff;\n}\n\n.trace-status {\n  margin: 10px 0;\n  color: #aaa;\n}\n\n.trace-output {\n  margin-top: 15px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.hop-card {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px;\n  background: #111a2e;\n  border-left: 3px solid #00ffcc;\n  border-radius: 6px;\n}\n\n.hop-left {\n  display: flex;\n  gap: 10px;\n}\n\n.hop-index {\n  color: #00ffcc;\n}\n\n.hop-ip {\n  color: #fff;\n}\n\n.hop-right {\n  display: flex;\n  gap: 15px;\n  color: #aaa;\n}\n\n.latency {\n  color: #00ffcc;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
